// Shared domain enums used by both api and site.
export const Role = { ADMIN: "ADMIN", MEMBER: "MEMBER" } as const;
export type Role = (typeof Role)[keyof typeof Role];

export const UserStatus = { INVITED: "INVITED", ACTIVE: "ACTIVE", DISABLED: "DISABLED" } as const;
export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];

export const PaymentFrequency = { MONTHLY: "MONTHLY", YEARLY: "YEARLY" } as const;
export type PaymentFrequency = (typeof PaymentFrequency)[keyof typeof PaymentFrequency];

export const TransactionStatus = { MATCHED: "MATCHED", UNMATCHED: "UNMATCHED", IGNORED: "IGNORED" } as const;
export type TransactionStatus = (typeof TransactionStatus)[keyof typeof TransactionStatus];

// What a conciliated *ingreso* (income) movimiento is for. (Per-type computation is deferred.)
export const MovementType = { CUOTA: "CUOTA", LOTERIA: "LOTERIA", INVITADO: "INVITADO", OTROS: "OTROS" } as const;
export type MovementType = (typeof MovementType)[keyof typeof MovementType];

// Supported bank statement formats for the importer. Each value selects a
// dedicated per-bank parser; new banks are added here and in the importer registry.
export const Bank = { BANC_SABADELL: "BANC_SABADELL" } as const;
export type Bank = (typeof Bank)[keyof typeof Bank];

// What a conciliated *gasto* (expense) movimiento is for. Extensible over time.
export const ExpenseCategory = {
  MUSICA: "MUSICA",
  VESTIDOS: "VESTIDOS",
  MAQUILLAJE: "MAQUILLAJE",
  CATERING: "CATERING",
  LOTERIA: "LOTERIA",
  COMISION_BANCO: "COMISION_BANCO",
  OTHER: "OTHER",
  COMIDA: "COMIDA",
  BEBIDA: "BEBIDA",
  FLORES: "FLORES",
  ALQUILER: "ALQUILER",
} as const;
export type ExpenseCategory = (typeof ExpenseCategory)[keyof typeof ExpenseCategory];

// How a previsión de gastos line is priced: a closed amount, or unit price × people.
export const ForecastLineKind = { TOTAL: "TOTAL", PER_PERSON: "PER_PERSON" } as const;
export type ForecastLineKind = (typeof ForecastLineKind)[keyof typeof ForecastLineKind];
